import { render, staticRenderFns } from "./page-cover.vue?vue&type=template&id=ead82b54&"
import script from "./page-cover.vue?vue&type=script&lang=js&"
export * from "./page-cover.vue?vue&type=script&lang=js&"
import style0 from "./page-cover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports